import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=6ab11b4e&"
import script from "./CatalogItem.vue?vue&type=script&lang=js&"
export * from "./CatalogItem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports